<template>
  <!-- 业务跟踪 -->
  <div>
    <div ref="searchBox">
      <div class="detailsTitle" style="justify-content: left; padding-top: 10px;">
        <h4>业务跟踪</h4>
        <div style="margin-left: 10px;">
          <el-button type="primary" size="mini" @click="fanhui">返 回</el-button>
          <el-button type="primary" size="mini" @click="baocun">保 存</el-button>

        </div>

        <br>
      </div>

    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :span-method="objectSpanMethod" :data="tableList" ref="table" bordersize="mini"
        @select="handelSelectTable" height="100%" style="width: 100%" center border>
        <el-table-column type="selection" align="center" width="60"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column property="businessProgress" min-width="100" label="业务进度"></el-table-column>
        <el-table-column property="progressIndicator" min-width="180" label="进展标识">
          <template slot-scope="scope">
            <el-input v-model="scope.row.progressIndicator" maxlength="50" v-if="scope.row.businessProgress == '商务沟通'"
              size="mini"></el-input>

            <el-input v-model="scope.row.progressIndicator" maxlength="50"
              v-else-if="scope.row.businessProgress == '协议签订'" size="mini"></el-input>

            <el-input v-model="scope.row.progressIndicator" maxlength="50"
              v-else-if="scope.row.businessProgress == '订单结束'" size="mini"></el-input>
            <el-input v-model="scope.row.progressIndicator" maxlength="50"
              v-else-if="scope.row.businessProgress == '发票开具'" size="mini"></el-input>
            <el-input v-model="scope.row.progressIndicator" maxlength="50"
              v-else-if="scope.row.businessProgress == '业务完结'" size="mini"></el-input>
            <span maxlength="50" v-else disabled size="mini">{{ scope.row.progressIndicator }}</span>
          </template>
        </el-table-column>
        <el-table-column property="weight" min-width="120" label="重量（吨）">
          <template slot-scope="scope">
            <el-input v-model="scope.row.weight" v-number-input.float="3"  maxlength="10" placeholder="" size="mini"></el-input>
          </template>
        </el-table-column>
        <el-table-column property="constitute" min-width="120" label="产值构成"></el-table-column>
        <el-table-column property="revenue" min-width="120" label="营收收入（元）">
          <template slot-scope="scope">
            <el-input v-model="scope.row.revenue" v-number-input.float="2"  maxlength="10" placeholder="" size="mini"></el-input>
          </template>
        </el-table-column>
        <el-table-column property="costPayment" min-width="120" label="成本支付（元）">
          <template slot-scope="scope">
            <el-input v-model="scope.row.costPayment" v-number-input.float="2"  maxlength="10" placeholder="" size="mini"></el-input>
          </template>
        </el-table-column>
        <el-table-column property="paymentObject" min-width="120" label="付款对象">
          <template slot-scope="scope">
            <el-input v-model="scope.row.paymentObject" maxlength="50" placeholder="" size="mini"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="grossProfitEstimate" label="毛利预估（元）" min-width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.grossProfitEstimate" v-number-input.float="2"  maxlength="10" placeholder="" size="mini"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="priceDescription" min-width="120" label="价格说明">
          <template slot-scope="scope">
            <el-input v-model="scope.row.priceDescription" maxlength="50" placeholder="" size="mini"></el-input>
          </template>
        </el-table-column>

        <el-table-column prop="remark" min-width="120" label="备注">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" maxlength="50" placeholder="" size="mini"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  getBusinessManagementDetailList,
  updateBusinessManagementDetail,
  accomplishSgOrder

} from '@/api/wms-stock'
export default {
  data () {
    return {
      h: '500px',
      checkedGh: [],
      id: this.$route.query.id,
      addFrom: this.$route.query.addFrom,
      title: this.$route.query.title,
      total: 0,
      tableList: [],
      btnFlg: [],
      btnIdArr: ['003P00RB001', '003P00RB002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/tracking')

    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 130 + 'px'
  },
  methods: {
    fanhui () {
      this.$router.go(-1)// 返回上一层
    },
    handelSelectTable (selection, row) {
      this.multipleSelection = row
      this.$refs.table.clearSelection() // 先清空选中状态，selection值还在
      if (selection.length === 0) {
        // 这里状态为勾选
        return
      }
      this.$refs.table.toggleRowSelection(row, true) // 用于切换某行选中状态
      this.tableList.forEach((item, index) => {
        item.currentBusinessProgress = 0
        row.currentBusinessProgress = 1
      })
    },

    handleCheckChange (data, checked, indeterminate) {
      if (checked) {
        this.$refs.dataTree.setCheckedKeys([data.lobbyCode])
      }
    },
    baocun () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })

      updateBusinessManagementDetail(this.tableList).then(res => {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        loading.close()
        this.getList()
      }).catch((err) => {
        loading.close()
        DonMessage.error(err.message)
      })
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // console.log(columnIndex, 'columnIndex')
      if (rowIndex === 2) {
        // 合并第二行
        if (columnIndex === 2) {
          // 从第二列开始
          return [9, 1]
        }
      }
      if (rowIndex <= 10 && rowIndex >= 3 && (columnIndex === 2)) {
        return [0, 0]
      }

      // ----------------------------------------------
      if (rowIndex === 2) {
        // 合并第二行
        if (columnIndex === 0) {
          // 从第二列开始
          return [9, 1]
        }
      }
      if (rowIndex <= 10 && rowIndex >= 3 && (columnIndex === 0)) {
        return [0, 0]
      }
      // ----------------------------------------
      if (rowIndex === 13) {
        // 合并第二行
        if (columnIndex === 2) {
          return [2, 1]
        }
      }
      if (rowIndex <= 15 && rowIndex == 14 && (columnIndex === 2)) {
        return [0, 0]
      }
    },

    // 获取列表
    getList () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })

      getBusinessManagementDetailList({
        id: this.id
      }).then(res => {
        this.tableList = res
        this.tableList.forEach((item, index) => {
          if (item.currentBusinessProgress == 1) {
            setTimeout(() => {
              this.$refs.table.setCurrentRow(item)
              this.$refs.table.toggleRowSelection(this.$refs.table.data[index])
            }, 10)
          }
        })
        loading.close()
      }).catch((err) => {
        loading.close()
        DonMessage.error(err.message)
      })
    }

  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
  margin-bottom: 10px;
}

.inpBox .el-date-editor {
  width: 350px !important;
}

.imgBox {
  display: flex;

  .item {
    display: flex;
    width: 50%;
    justify-content: space-around;
  }

  /deep/ .hide .el-upload--picture-card {
    display: none;
  }
}

.el-tag {
  margin: 0 4px !important;
}

.more_btn thead .el-table-column--selection .cell {
  display: none;
}

.liuxiang /deep/ .el-input__inner {
  width: 100%;
}

.liuxiang /deep/.el-select {
  width: 417px;
}
</style>
